import { z } from 'zod';

/** GET /config: configuração pública do ambiente (a SPA pergunta se é staging, se o cadastro está aberto). */
export const PublicConfig = z.object({
  env: z.enum(['development', 'test', 'staging', 'production']),
  publicSignup: z.boolean(),
  /** Textos obrigatórios de compliance, para o app e o site mostrarem sempre o mesmo. */
  compliance: z.object({ semGarantia: z.string(), juridico: z.string(), fee: z.string() }),
});
export type PublicConfig = z.infer<typeof PublicConfig>;

/**
 * Compliance: frases que nunca podem sair do produto (site, app, contrato, e-mails). Fonte única:
 * o site importa daqui e um teste impede o build sem elas; a API devolve as mesmas em /config.
 * `COMPLIANCE_PHRASES` são os trechos obrigatórios (redação do briefing); `COMPLIANCE` são as
 * frases completas, cada uma contendo literalmente o trecho correspondente.
 */
export const COMPLIANCE_PHRASES = [
  'sem garantia de vitória em licitação',
  'serviços jurídicos prestados por advogados parceiros, conforme as normas da OAB',
  'comissão de êxito incide apenas sobre valores efetivamente recebidos',
] as const;

export const COMPLIANCE = {
  semGarantia:
    'Assessoria em licitações e software, sem garantia de vitória em licitação. O licita.dev não tem relação com órgãos públicos.',
  juridico: 'Os serviços jurídicos prestados por advogados parceiros, conforme as normas da OAB, são contratados e cobrados à parte.',
  fee: 'A comissão de êxito incide apenas sobre valores efetivamente recebidos, nunca sobre ata ou homologação.',
} as const;
